import { render, staticRenderFns } from "./JsonEditor.vue?vue&type=template&id=4b03dc66&"
import script from "./JsonEditor.vue?vue&type=script&lang=ts&"
export * from "./JsonEditor.vue?vue&type=script&lang=ts&"
import style0 from "./JsonEditor.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports